export default __webpack_public_path__ + "static/media/spr-background.209ef89e.jpg";